import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Transition as _Transition, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-07da8d18"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "jour" };
var _hoisted_2 = { class: "screen-mode-toggler" };
var _hoisted_3 = { class: "chrono-slider--wrapper" };
var _hoisted_4 = { class: "dispatch-page__2cols row-max-height" };
var _hoisted_5 = { class: "transport-table--wrapper" };
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("br", null, null, -1 /* HOISTED */); });
var _hoisted_7 = { class: "resolution-map" };
var _hoisted_8 = {
    key: 0,
    class: "modal-title"
};
var _hoisted_9 = ["href"];
var _hoisted_10 = {
    key: 1,
    class: "modal-title modal-title--flex"
};
var _hoisted_11 = ["href"];
var _hoisted_12 = { class: "pre-json" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_minimize_icon = _resolveComponent("minimize-icon");
    var _component_n_icon = _resolveComponent("n-icon");
    var _component_maximize_icon = _resolveComponent("maximize-icon");
    var _component_n_button = _resolveComponent("n-button");
    var _component_ChronoSlider = _resolveComponent("ChronoSlider");
    var _component_TransportTable = _resolveComponent("TransportTable");
    var _component_n_text = _resolveComponent("n-text");
    var _component_SnapshotsMapView = _resolveComponent("SnapshotsMapView");
    var _component_TeamLabel = _resolveComponent("TeamLabel");
    var _component_TransportMarker = _resolveComponent("TransportMarker");
    var _component_JsonViewer = _resolveComponent("JsonViewer");
    var _component_n_config_provider = _resolveComponent("n-config-provider");
    return (_ctx.eveningId)
        ? (_openBlock(), _createBlock(_component_n_config_provider, {
            key: 0,
            "theme-overrides": _ctx.naiveThemeConfig,
            class: _normalizeClass(["dispatch-page", { 'full-screen': _ctx.fullScreenPageMode }])
        }, {
            default: _withCtx(function () { return [
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.formattedDate), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_n_button, {
                            text: "",
                            class: "screen-mode-toggler__button",
                            onClick: _ctx.toggleFullScreen
                        }, {
                            default: _withCtx(function () { return [
                                (_ctx.fullScreenPageMode)
                                    ? (_openBlock(), _createBlock(_component_n_icon, { key: 0 }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(_component_minimize_icon)
                                        ]; }),
                                        _: 1 /* STABLE */
                                    }))
                                    : (_openBlock(), _createBlock(_component_n_icon, { key: 1 }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(_component_maximize_icon)
                                        ]; }),
                                        _: 1 /* STABLE */
                                    }))
                            ]; }),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        (_ctx.timestamps.length > 0 && _ctx.startsAt && _ctx.endsAt)
                            ? (_openBlock(), _createBlock(_component_ChronoSlider, {
                                key: 0,
                                "starts-at": _ctx.startsAt,
                                "ends-at": _ctx.endsAt,
                                timestamps: _ctx.timestamps,
                                class: "chrono-slider",
                                onChange: _ctx.onChangeTimestamp
                            }, null, 8 /* PROPS */, ["starts-at", "ends-at", "timestamps", "onChange"]))
                            : _createCommentVNode("v-if", true),
                        (_ctx.transports.length)
                            ? (_openBlock(), _createBlock(_component_n_button, {
                                key: 1,
                                type: "primary",
                                size: "small",
                                onClick: _ctx.fetchAutoAssignment
                            }, {
                                default: _withCtx(function () { return [
                                    _createTextVNode("Résoudre")
                                ]; }),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_TransportTable, {
                            transports: _ctx.transports,
                            "is-editable": _ctx.isEditable,
                            timestamp: _ctx.timestamp,
                            "onTransport:inspect": _ctx.setTransportRequestInspected,
                            "onTeam:inspect": _ctx.setTeamInspected
                        }, null, 8 /* PROPS */, ["transports", "is-editable", "timestamp", "onTransport:inspect", "onTeam:inspect"]),
                        (_ctx.transports.length === 0)
                            ? (_openBlock(), _createBlock(_component_n_text, {
                                key: 0,
                                style: { "padding-left": "10px" }
                            }, {
                                default: _withCtx(function () { return [
                                    _hoisted_6,
                                    _createTextVNode("Aucune demande de transport")
                                ]; }),
                                _: 1 /* STABLE */
                            }))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        (_ctx.timestamp)
                            ? (_openBlock(), _createBlock(_component_SnapshotsMapView, {
                                key: 0,
                                "positioned-teams": _ctx.positionedTeams,
                                "un-positioned-teams": _ctx.unPositionedTeams,
                                transports: _ctx.transports,
                                "extra-class": "full--1rem",
                                "onTeam:inspect": _ctx.setTeamInspected,
                                "onTransport:inspect": _ctx.setTransportRequestInspected
                            }, null, 8 /* PROPS */, ["positioned-teams", "un-positioned-teams", "transports", "onTeam:inspect", "onTransport:inspect"]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _createVNode(_Transition, { name: "modal" }, {
                    default: _withCtx(function () { return [
                        (_ctx.inspected)
                            ? (_openBlock(), _createBlock(_component_JsonViewer, {
                                key: 0,
                                onClose: _cache[0] || (_cache[0] = function ($event) { return (_ctx.inspected = undefined); })
                            }, {
                                header: _withCtx(function () {
                                    var _a;
                                    return [
                                        (_ctx.inspected.type === 'Team')
                                            ? (_openBlock(), _createElementBlock("h5", _hoisted_8, [
                                                _createElementVNode("a", {
                                                    href: '/app/team/' + _ctx.inspected.body.id,
                                                    target: "_blank"
                                                }, [
                                                    _createVNode(_component_TeamLabel, {
                                                        team: _ctx.inspected.body
                                                    }, null, 8 /* PROPS */, ["team"])
                                                ], 8 /* PROPS */, _hoisted_9)
                                            ]))
                                            : (_ctx.inspected.type === 'TransportRequest')
                                                ? (_openBlock(), _createElementBlock("h5", _hoisted_10, [
                                                    _createVNode(_component_TransportMarker, {
                                                        num: _ctx.inspected.num,
                                                        status: _ctx.inspected.body.status,
                                                        style: { "margin-right": "0.5rem" }
                                                    }, null, 8 /* PROPS */, ["num", "status"]),
                                                    _createElementVNode("a", {
                                                        href: '/app/transport/' + _ctx.inspected.body.id,
                                                        target: "_blank"
                                                    }, _toDisplayString((_a = _ctx.inspected.title) !== null && _a !== void 0 ? _a : 'TransportRequest?'), 9 /* TEXT, PROPS */, _hoisted_11)
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                    ];
                                }),
                                body: _withCtx(function () {
                                    var _a;
                                    return [
                                        _createElementVNode("pre", _hoisted_12, _toDisplayString((_a = _ctx.inspected.body) !== null && _a !== void 0 ? _a : 'body?'), 1 /* TEXT */)
                                    ];
                                }),
                                _: 1 /* STABLE */
                            }))
                            : _createCommentVNode("v-if", true)
                    ]; }),
                    _: 1 /* STABLE */
                })
            ]; }),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["theme-overrides", "class"]))
        : _createCommentVNode("v-if", true);
}
